/**
 * Created by tomers on 3/3/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/defaultAgentStatusEdit.tmpl");
    var Button = require("ui/button/Button");
    var DefaultAgentStatusItemView = require("personalization-web-agent-views/default-agent-status/DefaultAgentStatusItemView");
    var positionsUtility = require("personalization-utils/positionsUtility");

    var DefaultAgentStatusEditView = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        DefaultAgentStatusEditView = Marionette.CompositeView.extend({
            template: template,
            className: "default-agent-status-edit-view anchor",
            itemView: DefaultAgentStatusItemView,
            itemViewContainer: ".status-list-container",
            ui: {
                saveButton: ".save-button",
                cancelButton: ".cancel-button"
            },
            uiComponents: {
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                }
            },
            itemEvents: {
                statusRadioChange: "_onStatusRadioChange"
            },

            initialize: function (options) {
                this.anchorSelector = options.anchorSelector;
                this.currentDefaultAgentStatus = options.currentDefaultAgentStatus;
                this.collection = options.collection;

                this._setCollectionComparator();

            },
            itemViewOptions: function(model) {
                return {
                    isSelected: (model.get("value") === this.currentDefaultAgentStatus.get("value"))
                };
            },
            onRender: function () {
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.RIGHT, positionsUtility.POSITION_Y.TOP);
                if (offset) {
                    this.$el.css(offset);
                }
                this._restoreCollectionComparator();
            },

            /**
             * We have to set a different comparator in the collection (the opposite one).
             * We set it on the initialize and restore it to the old comparator after we render the collection
             * @private
             */
            _setCollectionComparator: function() {
                this.oldCollectionComparator = this.collection.comparator;
                this.collection.comparator = this._comparator;
                this.collection.sort();
            },
            _restoreCollectionComparator: function() {
                this.collection.comparator = this.oldCollectionComparator;
                this.collection.sort();
            },
            _comparator: function(model) {
                return (0 - model.get("index"));
            },

            _onStatusRadioChange: function(eventName, itemView) {
                this.trigger("defaultAgentStatus:change", itemView.model);
            },
            _onSave: function () {
                this.trigger("defaultAgentStatus:save");
            },
            _onCancel: function () {
                this.trigger("defaultAgentStatus:cancel");
            }
        });
    });

    return DefaultAgentStatusEditView;

});
